export const ACTION_COLUMN_WIDTH = "fit-content"

export const HEADER_ROW_HEIGHT = 42
export const SELECTION_BANNER_HEIGHT = 50

const TAG_COLUMN = {
    field: "tag",
    label: "Asset Tag",
    description: "The asset tag is the unique id you have for an asset.",
    kind: "tag",
    importance: 1,
    unique: true,
    required: true,
}
const SPECIAL_COLUMNS = [
    { field: "summary", label: "Summary", kind: "summary", sortField: "score" },
    { field: "minutes", label: "Minutes", kind: "minutes", align: "right" },
    { field: "tasks", label: "Tasks", kind: "tasks", align: "right" },
    { field: "schedules", label: "Schedules", kind: "schedules" },
]

export function buildAllColumns(displayFields = []) {
    return [TAG_COLUMN, ...displayFields, ...SPECIAL_COLUMNS].map(toColumn)
}

function toColumn(field) {
    return {
        ...field,
        label: field.label ?? toLabel(field.field),
        kind: field.kind ?? "field",
        pinnable: true,
        hideable: !field.required,
    }
}

function toLabel(fieldName) {
    return fieldName.replace(/([A-Z])/g, " $1").replace(/^./, (c) => c.toUpperCase())
}
